var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortaverage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5859 5.79596C16.8598 6.06387 16.8598 6.49809 16.5859 6.76545L12.803 10.4657C12.9153 10.7077 12.9779 10.9766 12.9779 11.259C12.9779 12.3261 12.0908 13.1935 11 13.1935C9.90975 13.1935 9.02237 12.3261 9.02237 11.259C9.02237 10.1926 9.90975 9.32445 11 9.32445C11.2892 9.32445 11.5636 9.3862 11.8115 9.49574L15.5942 5.79596C15.868 5.52806 16.312 5.52806 16.5859 5.79596ZM11 4.9044C11.7711 4.9044 12.5253 5.03508 13.2411 5.29228C13.6046 5.42301 14.0078 5.24073 14.1415 4.8852C14.2746 4.52967 14.0885 4.1358 13.725 4.00507C12.8534 3.69187 11.9366 3.53278 11 3.53278C6.64437 3.53278 3.10072 6.99878 3.10072 11.259C3.10072 11.6379 3.41486 11.9449 3.80178 11.9449C4.18921 11.9449 4.50307 11.6379 4.50307 11.259C4.50302 7.75539 7.41766 4.9044 11 4.9044ZM20.3299 13.4694C20.5078 12.7498 20.5977 12.0061 20.5977 11.259C20.5977 6.08325 16.2921 1.87161 11 1.87161C5.7081 1.87161 1.40258 6.08329 1.40258 11.259C1.40258 12.0061 1.49267 12.7498 1.67064 13.4694C1.76788 13.8637 2.11203 14.1284 2.52646 14.1284H19.4741C19.8885 14.1284 20.2326 13.8637 20.3299 13.4694ZM18.7784 3.65153C16.7007 1.61918 13.9383 0.5 11 0.5C8.06193 0.5 5.29979 1.61914 3.22214 3.65153C1.14449 5.68366 0 8.38532 0 11.259C0 12.1147 0.103365 12.9667 0.307219 13.7918C0.555658 14.7974 1.46822 15.5 2.52642 15.5H19.474C20.5317 15.5 21.4443 14.7974 21.6927 13.7918C21.8966 12.9662 22 12.1142 22 11.259C22 8.38532 20.8558 5.6837 18.7784 3.65153Z",
    fill: "#3686F0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortaverage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohortaverage.b3f4b03dc22e416e851c330253715cbd.svg";